import { showStartEndTimeZoneOption } from './TimezoneButton.locstring.json';
import { IButtonStyles, IconButton } from '@fluentui/react/lib/Button';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { observer } from 'mobx-react-lite';
import { toggleShowDateSelectorTimeZones } from 'owa-calendar-compose-form-actions';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { timeZoneText } from 'owa-locstrings/lib/strings/timezonetext.locstring.json';
import * as React from 'react';

const styles = require('./FullComposeLeftPane.scss');

export interface TimezoneButtonProps {
    buttonStyle: IButtonStyles;
}

export default observer(function TimezoneButton(props: TimezoneButtonProps) {
    const fullComposeViewState = getFullComposeViewState();

    return (
        <div className={styles.timeZoneButtonContainer}>
            <TooltipHost content={loc(timeZoneText)}>
                <IconButton
                    className={styles.timeZoneButton}
                    iconProps={{ iconName: ControlIcons.Globe2 }}
                    onClick={toggleShowDateSelectorTimeZones}
                    styles={props.buttonStyle}
                    role="switch"
                    aria-label={loc(showStartEndTimeZoneOption)}
                    aria-checked={fullComposeViewState.showDateSelectorTimeZones}
                />
            </TooltipHost>
        </div>
    );
});
